import { DeviceSyncStatus, SyncState } from '@rocksoft/apple-sync-sdk';

const REQUIRED_SYNC_STATES: readonly (keyof DeviceSyncStatus)[] = [
  'wifiProfiles',
  'notificationProfiles',
  'appLockProfile',
  'applicationConfigurations',
  'applications',
  'restrictionsProfiles',
  'airPlaySecurityProfile',
  'configurationProfiles',
];

export function isDeviceInCorrectSyncState(status: DeviceSyncStatus | undefined): boolean {
  return (
    !!status &&
    REQUIRED_SYNC_STATES.every((property) => {
      const state = status[property];
      return state === SyncState.Successful || state === SyncState.Verify;
    })
  );
}
